import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/product`); // Adjust the API endpoint as needed
        const sortedProducts = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setProducts(sortedProducts.slice(0, 8)); // Get the latest 8 products
        setLoading(false);
      } catch (error) {
        console.error("Error fetching the products:", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <ClipLoader color={"#EF4444"} size={50} />
      </div>
    );
  }

  return (
    <div className="mb-10">
      <div className="text-center">
        <p className="text-xl md:text-3xl font-medium font-sans text-gray-800">
          Checkout Products
        </p>
      </div>
      <p className="text-center text-gray-500 text-sm md:text-base">
        Discover the latest trends in streetwear
      </p>
      <div className="w-9 h-0.5 bg-red-600 mx-auto mt-4 md:mb-12 mb-6"></div>
      <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-1 md:gap-8 mb-4">
        {products.map((product) => (
          <Link
            to={`/product/${product._id}`} // Assuming the product has an _id field
            key={product._id}
            className="bg-gray-100 overflow-hidden md:rounded-md transform transition duration-300 md:hover:scale-105 hover:shadow-lg"
          >
            {product.images && (
              <img
                src={`${process.env.REACT_APP_URL}/${product.images[0]}`} // Replace '\\' with '/' in the path
                alt={product.name}
                className="w-full md:h-[480px] h-[280px] object-cover"
              />
            )}
            <div className="p-4">
              <h3 className="text-md font-twentieth-century font-medium text-gray-800 truncate">
                {product.name}
              </h3>
              <h3 className="text-md font-twentieth-century font-medium text-gray-800">
                ₹{product.price}
              </h3>
            </div>
          </Link>
        ))}
      </div>
      <div className="flex justify-center mt-4">
        <Link
          to={`/allproduct/${'allproduct'}`}
          className="inline-flex items-center justify-center w-60 h-12 rounded-sm border-2 text-red-600 border-red-600 hover:bg-red-600 hover:text-white mt-6"
        >
          <span className="font-mono text-sm font-semibold">
            VIEW ALL PRODUCTS &rarr;
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ProductList;
